import React, { useContext, useState } from "react";
import { Box } from "Components/Base/Layout/Box";
import {
  PROP_TYPE_PROGRAM_COURSE,
  PROP_DEFAULT_PROGRAM_COURSE,
} from "../../../../propTypes";
import LangContext from "../../../../langContext";
import Description from "../../../Description";
import AddActivity from "domains/talentmanagement/coworker/goals/addactivity";
import config from "lib/config";
import { API_PROGRAM_ACTIVITY } from "lib/endpoints/programs";
import { Stack } from "Components/Base/Feedback/Stack";
import { Skeleton } from "Components/Base/Feedback/Skeleton";
import {
  StyledEmptyProgress,
  StyledEmptyTag,
  StyledEmptyDescription,
  formatCourseDuration,
} from "../../../../functions";
import { sanitize } from "lib/sanitizer.js";
import { AddLinebreaksRemoveHtmlTags } from "lib/utils";
import { GET } from "lib/api";

const { personalId } = config;

const fetchActivity = async (activityId, activityType) => {
  let activity =
    (await GET(API_PROGRAM_ACTIVITY, {
      activityId,
    })) || [];

  activity.type = "programotheractivity";

  if (activityType === "CommonActivity") {
    activity.type = "programcommonactivity";
  }

  return activity;
};

const ProgramTypeActivity = (props) => {
  const languageContext = useContext(LangContext);
  const [displayActivity, setDisplayActivity] = useState(false);
  const [activityDetails, setActivityDetails] = useState(null);
  const { activity, setCompleted, isPreview, isManager } = props;
  const displayDescription =
    (activity.itemDescription && activity.itemDescription !== "") ||
    (activity.stepDescription && activity.stepDescription !== "");
  const descriptionText = activity.stepDescription || activity.itemDescription;

  const displayTime = formatCourseDuration(activity);

  const toggleActivity = async (activityId, refreshOnly) => {
    if (!activityDetails || refreshOnly) {
      let activityData = await fetchActivity(activityId, activity.type);

      activityData = { id: activityId, ...activityData };
      setActivityDetails(activityData);
      setCompleted(activityData.isCompleted);
    }
    if (!refreshOnly) setDisplayActivity(true);
  };

  const onActivitySave = () => {
    toggleActivity(activity.personalPlannedCoursesId, true);
    setDisplayActivity(false);
  };

  const onActivityReset = () => {
    setDisplayActivity(false);
  };

  return (
    <div>
      <br />

      {displayDescription ? (
        <Description>
          <span
            title={AddLinebreaksRemoveHtmlTags(sanitize(descriptionText))}
            dangerouslySetInnerHTML={{ __html: sanitize(descriptionText) }}
          />
        </Description>
      ) : (
        <StyledEmptyDescription />
      )}

      {activity.requested && (
        <span className="tag-warning">
          {languageContext("courserequested")}
        </span>
      )}

      <StyledEmptyTag className="card-empty-tag" />

      <StyledEmptyProgress />

      <Box
        display="flex"
        width="100%"
        justifyContent={displayTime ? "space-between" : "center"}
      >
        {displayTime && (
          <span>
            <span className="icon-time" aria-hidden="true" />
            &nbsp;{displayTime}
          </span>
        )}

        {activity.isActiveStep && !isPreview && (
          <div>
            <button
              className="button-transparent pointer"
              aria-label={languageContext("displayActivity")}
              onClick={() =>
                toggleActivity(activity.personalPlannedCoursesId, false)
              }
            >
              {languageContext("displayActivity")}
            </button>
          </div>
        )}
      </Box>

      {displayActivity && !activityDetails && (
        <Stack spacing={1}>
          <Skeleton variant="rectangular" width={210} height={60} />
        </Stack>
      )}

      {displayActivity && activityDetails && (
        <AddActivity
          activity={activityDetails}
          onRefresh={() => {}}
          onShowSaveNotification={() => onActivitySave()}
          personalId={personalId}
          isManager={isManager}
          resetEditActivity={() => onActivityReset()}
          refreshOnClose={true}
          allowAttachment={true}
          fromProgramPage={true}
        />
      )}
    </div>
  );
};

ProgramTypeActivity.propTypes = {
  activity: PROP_TYPE_PROGRAM_COURSE,
};

ProgramTypeActivity.defaultProps = {
  activity: PROP_DEFAULT_PROGRAM_COURSE,
};

export default ProgramTypeActivity;
